module.exports = __webpack_public_path__ + "assets/img/img221.d5249c86.png";